module.exports = __webpack_public_path__ + "img/cover_photo.6bf23e1a.jpg";